import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index'
import TheHeader from './components/layout/TheHeader.vue';
import TheFooter from './components/layout/TheFooter.vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js/dist/Chart';
import VueGeolocation from "vue3-geolocation";
import GMaps from './components/Admin/Orders/Gmaps';
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'



const app = createApp(App);
const VueTelInputOptions = {
    mode: "international",
    onlyCountries: ['NG', 'GH', "GB", "US", "CA"]
  }
app.component('the-header', TheHeader);
app.component('the-footer', TheFooter);
app.use(router);
app.use(window.VueCharts);
app.use(Chartkick.use(Chart));
// app.use(window.vuelidate.default)
app.use(store);
app.use(VueGeolocation);
app.use(GMaps, {
  load: {
    apiKey: "AIzaSyBNYAld3avvW841AOAnHChp0PAfvZWsUlA",
    libraries: ["places"],
  },
});
app.use(VueTelInput, VueTelInputOptions); 
app.mount('#app')
